import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import * as ActionEvents from '../actions/Specialties.Actions';
import { SpecialtiesState, SpecialtiesUnloadState } from '../states/Specialties.State';
import { SpecialtyViewModel } from '../../models/Entities/Specialties/SpecialtyModels';

export type KnownAction =
    | Actions.Specialties.SpecialtiesGetAllRequestAction
    | Actions.Specialties.SpecialtiesGetAllSuccessAction
    | Actions.Specialties.SpecialtiesGetAllFailureAction
    | Actions.Specialties.SpecialtiesGetByIdRequestAction
    | Actions.Specialties.SpecialtiesGetByIdSuccessAction
    | Actions.Specialties.SpecialtiesGetByIdFailureAction
    | Actions.Specialties.SpecialtiesCreateRequestAction
    | Actions.Specialties.SpecialtiesCreateSuccessAction
    | Actions.Specialties.SpecialtiesCreateFailureAction
    | Actions.Specialties.SpecialtiesUpdateRequestAction
    | Actions.Specialties.SpecialtiesUpdateSuccessAction
    | Actions.Specialties.SpecialtiesUpdateFailureAction
    | Actions.Specialties.SpecialtiesDeleteRequestAction
    | Actions.Specialties.SpecialtiesDeleteSuccessAction
    | Actions.Specialties.SpecialtiesDeleteFailureAction;

export const SpecialtiesReducer: Reducer<SpecialtiesState> = (
    state: SpecialtiesState | undefined,
    incomingAction: Action
): SpecialtiesState => {
    if (state === undefined) {
        return SpecialtiesUnloadState as SpecialtiesState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case ActionEvents.SPECIALTIES_GETALL_REQUEST:
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: undefined,
                failOnLoadingAll: false,
                error: undefined
            };
        case ActionEvents.SPECIALTIES_GETALL_SUCCESS:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                list: action.payload,
                error: undefined
            };
        case ActionEvents.SPECIALTIES_GETALL_FAILURE:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };

        case ActionEvents.SPECIALTIES_GETBYID_REQUEST:
            return {
                ...state,
                isLoadingOne: true,
                successLoadingOne: undefined,
                failOnLoadingOne: false,
                error: undefined
            };
        case ActionEvents.SPECIALTIES_GETBYID_SUCCESS: {
            const filtered = state.list.filter((item: SpecialtyViewModel) => item.id !== action.payload.id);
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                list: [...filtered, action.payload],
                error: undefined
            };
        }
        case ActionEvents.SPECIALTIES_GETBYID_FAILURE:
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: action.error
            };

        case ActionEvents.SPECIALTIES_CREATE_REQUEST:
            return {
                ...state,
                isAddingNewOne: true,
                successAddingNewOne: undefined,
                failOnAddingNewOne: false,
                error: undefined
            };
        case ActionEvents.SPECIALTIES_CREATE_SUCCESS: {
            const list = state.list.some((item) => item.id === action.payload.id)
                ? state.list.map((item) => (item.id === action.payload.id ? action.payload : item))
                : [...state.list, action.payload];
            return {
                ...state,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                lastCreated: action.payload,
                list,
                error: undefined
            };
        }
        case ActionEvents.SPECIALTIES_CREATE_FAILURE:
            return {
                ...state,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: action.error
            };

        case ActionEvents.SPECIALTIES_UPDATE_REQUEST:
            return {
                ...state,
                isUpdatingOne: true,
                successUpdatingOne: undefined,
                failOnUpdatingOne: false,
                error: undefined
            };
        case ActionEvents.SPECIALTIES_UPDATE_SUCCESS: {
            const updatedList = state.list.some((item) => item.id === action.payload.id)
                ? state.list.map((item) => (item.id === action.payload.id ? { ...item, ...action.payload } : item))
                : [...state.list, action.payload];
            return {
                ...state,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                list: updatedList,
                error: undefined
            };
        }
        case ActionEvents.SPECIALTIES_UPDATE_FAILURE:
            return {
                ...state,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: action.error
            };

        case ActionEvents.SPECIALTIES_DELETE_REQUEST:
            return {
                ...state,
                isDeletingOne: true,
                successDeletingOne: undefined,
                failOnDeletingOne: false,
                error: undefined
            };
        case ActionEvents.SPECIALTIES_DELETE_SUCCESS:
            return {
                ...state,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                list: state.list.filter((item: SpecialtyViewModel) => item.id !== action.id),
                error: undefined
            };
        case ActionEvents.SPECIALTIES_DELETE_FAILURE:
            return {
                ...state,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: action.error
            };
        default:
            return state;
    }
};
